var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preference-switch" },
    [
      _c("label", { attrs: { for: _vm.label } }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("BetSlip.placement." + _vm.label + ".label")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("v-checkbox", {
        attrs: { id: _vm.id, disabled: _vm.currentBetSlipState >= 2 },
        on: {
          click: function($event) {
            return _vm.toggleSettings(_vm.id)
          }
        },
        model: {
          value: _vm.combo,
          callback: function($$v) {
            _vm.combo = $$v
          },
          expression: "combo"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76922d1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76922d1d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslip/preferenceSwitch.vue
// module id = null
// module chunks = 